export enum Gender {
    Male = 'male',
    Female = 'female'
}

export function getGenderFromIndex(index: number): Gender {
    return index === 0 ? Gender.Male : Gender.Female;
}
